import { useEffect, useRef, useState } from "react";

/**
 * Animated count-up. Soft roll-up on mount and on any `value` change.
 * `value`    — target numeric value (can be negative)
 * `duration` — ms (defaults to 1200 for a premium, unhurried feel)
 * `format`   — optional formatter fn
 */
export default function CountUp({ value, format, duration = 1200, className = "" }) {
  const [display, setDisplay] = useState(0);
  const start = useRef(0);
  const from = useRef(0);
  const rafRef = useRef(0);

  useEffect(() => {
    const target = Number(value) || 0;
    from.current = display;
    start.current = performance.now();
    const step = (t) => {
      const elapsed = t - start.current;
      const p = Math.min(elapsed / duration, 1);
      // easeOutExpo — punchy start, glassy tail
      const eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      setDisplay(from.current + (target - from.current) * eased);
      if (p < 1) rafRef.current = requestAnimationFrame(step);
      else setDisplay(target);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, duration]);

  return (
    <span className={className} style={{ fontVariantNumeric: "tabular-nums" }}>
      {format ? format(display) : display.toFixed(2)}
    </span>
  );
}
